import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ImageOption, ImageUrls } from '../../models/chat';
import { CommonModule } from '@angular/common';
import { ChatService } from '../../services/chat.service';
import { MatDialog } from '@angular/material/dialog';
import { ImageDialogComponent } from '../image-dialog/image-dialog.component';
import { PageLoaderComponent } from '../page-loader/page-loader.component';
import { SnackBarService } from '../../services/snack-bar.service';

@Component({
  selector: 'app-answer-image-button',
  standalone: true,
  imports: [
    CommonModule,
    PageLoaderComponent
  ],
  templateUrl: './answer-image-button.component.html',
  styleUrl: './answer-image-button.component.scss'
})
export class AnswerImageButtonComponent {

  // image option consisting of key, name and image category
  @Input() answer!:ImageOption;
  // selected answer flag
  @Input() selected = false;
  // loading flag for image
  loadingImage = false;
  // images array
  images:string[] = [];

  @Output() sendAnswerEvent = new EventEmitter<string>();

  constructor(private chatService:ChatService, public dialog: MatDialog, private snackBarService:SnackBarService){}

  showImage(key:string,imageCategory:string){
    this.loadingImage = true;
    this.chatService.getSignedImages(key, imageCategory).subscribe({
      next: (res: ImageUrls) => {
        this.loadingImage = false;
        this.images = res.images;
        if(this.images.length > 0){
          this.openImageDialog();
        } else {
          this.snackBarService.openSnackBar("No Images found for " + this.answer.name, "Dismiss", 5000);
        }
      },
      error: (error) => {
        this.loadingImage = false;
        this.snackBarService.showErrorMessage(error.error.statusCode);
      }
    })
  }

  openImageDialog(): void {
    const dialogRef = this.dialog.open(ImageDialogComponent, {
      data: {
        images: this.images,
        displayText: this.answer.name
      },
    });

    // disable close on outside click
    dialogRef.disableClose = true;

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.images = [];
      }
    });
  }

  sendOptions(answer:string){
    this.sendAnswerEvent.emit(answer);
  }

}
